import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GLOBAL } from './global';
import * as moment from "moment";
import 'rxjs/add/operator/map';

@Injectable()
export class AuthService {
  url_collection:string = GLOBAL.url+"loginapi";
  isLogged:boolean = false;
  user:any;
  long_session = false;

  constructor( private http:HttpClient ) {}

  public login(prov:any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
      })
    };

    return this.http.post(this.url_collection, prov, httpOptions)
    .map(
      (data) => {
        //console.log("respuesta de Login usuario: ",data);
        this.isLogged = true;
        this.setSession(data);
        this.getProfile().subscribe((res:any) =>{
          //console.log("Perfil de usuario: ",res);
          this.user = res;
          localStorage.setItem('roles', JSON.stringify(res.relationships.roles.data));
          this.updateSessionTime();
        });
      },
      (error) => {
        console.log(error);
      }
    );
  }

  private getProfile(){
    return this.http.get( GLOBAL.url+'user_profile' ).map( res => {
        return res;
    });
  }

  private updateSessionTime(){
      let roles = this.user['relationships']['roles']['data'];
      for (let key in roles) {
        if( roles[key].attributes.name == 'Empaque' || roles[key].attributes.name == 'Etiquetado'){
            this.long_session = true;
        }
      }
  }

  private setSession(authResult) {
    const expiresAt = moment().add(30,'minute');
    localStorage.setItem('id_token', authResult.success.token);
    localStorage.setItem("expires_at", JSON.stringify(expiresAt.valueOf()) );
  }

  private addTimeSession(){
    const expiresAt = (this.long_session == true)? moment().add(6,'hour'): moment().add(30,'minute');
    localStorage.setItem("expires_at", JSON.stringify(expiresAt.valueOf()) );
  }

  logout() {
    localStorage.removeItem("id_token");
    localStorage.removeItem("expires_at");
    localStorage.removeItem("roles");
  }

  public isLoggedIn() {
    let result = moment().isBefore(this.getExpiration());
    if(result){
      this.addTimeSession();
    }
    return result;
  }


  isLoggedOut() {
    return !this.isLoggedIn();
  }

  getExpiration() {
    const expiration = localStorage.getItem("expires_at");
    const expiresAt = JSON.parse(expiration);
    return moment(expiresAt);
  }

  public getMenus(){
    let url = GLOBAL.url+'users_menus';
    return this.http.get(url).map( res => {
        return res;
    });
  }

  public save(prov:any){
    return this.http.post(this.url_collection, prov)
    .map( data => {
      return data;
    });
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/services/auth.service.ts